module.exports = __webpack_public_path__ + "img/dribbble-square.03fe390f.svg";